// extracted by mini-css-extract-plugin
export var blink = "_styles-module--blink--l0oa0";
export var image = "_styles-module--image--5R5O6";